import { Observable, Subject } from 'rxjs';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { INotitieDb } from '../../shared/offline/cobradb';
import { IStateOptions2, ISearchResult } from '../../shared/state';
import { ActivatedRoute, Router } from '@angular/router';
import { NotitiesService, defaultNotitieStateOptions } from '../notities.service';
import { map, filter, switchMap } from 'rxjs/operators';
import { AppService } from '../../shared/app.service';
import { createCmdFactory } from '@cevi/rxjscommands';
import { INotitiesSearchArg } from 'src/app/shared/routing-params/RoutingParams';
import { ICommonSearchArgs } from 'src/app/shared/common-search-args';
import { NotitieListComponent } from '../../shared/notities/notitie-list/notitie-list.component';
import { FormsModule } from '@angular/forms';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';


interface IPeriode {
  omschrijving: string;
  value: string;
}

interface IZoekNotitiesVm {
  notities: INotitieDb[];
  searchArg: INotitiesSearchArg;
  periodes: IPeriode[];
  hasMoreResults?: boolean;
}

@Component({
    selector: 'app-notitie-zoeken',
    templateUrl: './notitie-zoeken.component.html',
    styleUrls: ['./notitie-zoeken.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, FormsModule, NgFor, NotitieListComponent, AsyncPipe],
    providers:[NotitiesService]
})
export class NotitieZoekenComponent implements OnInit {

  vm$: Observable<IZoekNotitiesVm>;
  vm: IZoekNotitiesVm;

  searchCmdSubj = new Subject<boolean>();
  searchMoreCmdSubj = new Subject<boolean>();
  navigateToPuntenCmd = new Subject<boolean>();
  navigateToDocumentZittingCmd = new Subject<boolean>();
  resetFilterCmd = new Subject<boolean>();

  constructor(private notitieService: NotitiesService,
    private appService: AppService,
    private route: ActivatedRoute) {

    this.appService.routing.createCurrentHistoryItem('Notities');

    const cmdFactory = createCmdFactory<IZoekNotitiesVm>();
    cmdFactory.addMapAction(this.searchFromQueryParamsAction$, 'searchFromQueryParams');
    cmdFactory.addMapAction(this.navigateFromSearchCmdAction$, 'navigateFromSearchCmd');
    cmdFactory.addMapAction(this.navigateFromSearchMoreSubjAction$, 'navigateFromSearchMore');
    cmdFactory.addMapAction(this.navigateFromResetFilterSubjAction$, 'navigateFromResetFilter');
    this.vm$ = cmdFactory.merge(this.getInitial());

  }

  getInitial(): IZoekNotitiesVm {
    return {
      hasMoreResults: false,
      notities: [],
      periodes: this.periodes,
      searchArg: this.getDefaultSearchArg()
    } as IZoekNotitiesVm;
  }
  getDefaultSearchArg() {
    return {
      CombineWordsWith: ' or ',
      CurrentPage: 0,
      PageSize: 20,
      PeriodeFilter: 'y',
      SearchFor: '',
      SoortNotities: 'alle',
    } as ICommonSearchArgs;
  }

  periodes: IPeriode[] = [
    { omschrijving: 'Huidig jaar', value: 'y' },
    { omschrijving: 'Afgelopen maand', value: '-1m' },
    { omschrijving: 'Afgelopen jaar', value: '-1y' },
    { omschrijving: 'Afgelopen 2 jaar', value: '-2y' },
    { omschrijving: 'Aangepaste periode', value: 'C' }
  ];

  ngOnInit() {
  }

  private searchFromQueryParamsAction$ = this.route.paramMap.pipe(
    map(paramMap => this.appService.routing.paramMapToSearchArgs(paramMap, this.getDefaultSearchArg())),
    filter(searchArgs => searchArgs.PeriodeFilter !== 'C' || (searchArgs.PeriodeFilter === 'C' && searchArgs.VanJaar != null)),
    switchMap(searchArg => this.notitieService.zoekNotities(searchArg).pipe(map(result => ({ result, searchArg })))),
    map(data => (vm: IZoekNotitiesVm) => {
      this.appService.routing.setBackStateOptions({ allowFromCache: true, page: (window.history.state as IStateOptions2).page, concat: false });
      return {
        ...vm,
        notities: data.result.items,
        searchArg: data.searchArg,
        hasMoreResults: data.result.hasMoreResults
      } as IZoekNotitiesVm;
    })
  );

  private navigateFromSearchCmdAction$ = this.searchCmdSubj.pipe(
    map(_ => (vm: IZoekNotitiesVm) => {
      // vm.searchArg.CurrentPage = '0';
      this.appService.routing.navigateToZoekNotities(vm.searchArg);
      return vm;
    })
  );

  private navigateFromSearchMoreSubjAction$ = this.searchMoreCmdSubj.pipe(
    map(_ => (vm: IZoekNotitiesVm) => {
      const page = { ...defaultNotitieStateOptions, ...window.history.state as IStateOptions2 }.page + 1;
      const searchArg: ICommonSearchArgs = { ...vm.searchArg, CurrentPage: page, t: new Date().getTime() };
      const stateOptions: IStateOptions2 = { allowFromCache: false, concat: true, page };
      this.appService.routing.navigateToZoekNotities(searchArg, stateOptions);
      return vm;
    })
  );

  private navigateFromResetFilterSubjAction$ = this.resetFilterCmd.pipe(
    map(_ => (vm: IZoekNotitiesVm) => {
      this.appService.routing.navigateToZoekNotities(this.getDefaultSearchArg());
      return vm;
    })
  );

  // private navigateFromResetFilterSubj = {
  //   name: '',
  //   source$: this.resetFilterCmd,
  //   process: (vm: IZoekNotitiesVm, _: boolean) => {
  //     this.appService.routing.navigateToZoekNotities(this.getDefaultSearchArg());
  //     return vm;
  //   }
  // };

  public navigateToZoekAgendapunten = (searchArg: ICommonSearchArgs) => {
    this.appService.routing.navigateToZoekAgendapunten(searchArg);
  }
  public navigateToZoekDocumentenZitting = (searchArg: ICommonSearchArgs) => {
    this.appService.routing.navigateToZoekDocumentenZitting(searchArg);
  }

  public resetFilter=()=>{
    this.resetFilterCmd.next(false);
    return false;
  }

}
